const createActionType = actionType => ({
    NAME: actionType,
    REQUEST: `${actionType}_REQUEST`,
    SUCCESS: `${actionType}_SUCCESS`,
    ERROR: `${actionType}_ERROR`
});

export default createActionType;